// Common bundle entry. Shared low-priority JS that should run on every page.
// Other agents may add imports here for global features (dark-mode, dropzone).
// Keep this minimal — heavy libs are lazy-loaded via window.PDFNinja.loadPdfLib/loadPdfJs.

window.PDFNinja = window.PDFNinja || {};
window.PDFNinja.version = '1';

// Eager-warm CDN connections after first idle, so the first file-input
// interaction starts the actual fetch from a warm socket.
function warmCdns() {
  if (!('requestIdleCallback' in window)) return;
  requestIdleCallback(() => {
    try {
      ['https://cdnjs.cloudflare.com', 'https://cdn.jsdelivr.net'].forEach((h) => {
        const l = document.createElement('link');
        l.rel = 'preconnect';
        l.href = h;
        l.crossOrigin = 'anonymous';
        document.head.appendChild(l);
      });
    } catch (e) {}
  }, { timeout: 5000 });
}
warmCdns();

export {};
